import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
  },
  sidebar: {
    height: "95vh",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    backgroundColor: theme.palette.primary.alt,
    padding: theme.spacing(2),
  },
  profilePicture: {
    display: "flex",
    justifyContent: "center",
  },
  displayName: {
    display: "flex",
    justifyContent: "center",
    color: theme.palette.primary.contrastText,
    fontWeight: "bold",
    fontSize: 40,
  },
  nav: {
    display: "flex",
    flexDirection: "column",
    paddingTop: theme.spacing(4),
  },
  navTitle: {
    display: "flex",
    justifyContent: "center",
    color: theme.palette.primary.contrastText,
    fontSize: 24,
    textDecoration: "underline",
    paddingBottom: theme.spacing(1),
  },
  list: {
    listStyleType: "none",
  },
  listItem: {
    display: "flex",
    justifyContent: "center",
    color: theme.palette.primary.contrastText,
    fontSize: 20,
    marginBottom: theme.spacing(2),
    paddingRight: theme.spacing(6),
  },
  main: {
    flexGrow: 4,
  },
}));

export default useStyles;
